import React from 'react';
import { Container } from 'react-bootstrap';
import "./Sabka_Vikas_Banner.css";

function Sabka_Vikas_Banner() {
  return (
    <section className='Sabka_Vikas_Banner'>
    <div className='container'>
      <div className="sabka_vikas">
        <img 
          src="/assets/images/about_us/vikas.png"
          alt="banner-img"
          className="banner_img"
        />
      </div>
    </div>
    </section>
  );
}

export default Sabka_Vikas_Banner;
